import { cn } from "@rekati/utils";
import corners from "../assets/mural-corners.svg";

/**
 * iForte's mural growing in from both bottom corners (Template 1), fixed
 * behind the page: the whole image from md up, and on a phone two crops of its
 * outer edges so the art stays in the corners. Decorative only. The page puts
 * its content above it (relative, z-10).
 */
export function MuralCorners() {
  const img = "absolute bottom-0 h-full w-auto max-w-none select-none";
  return (
    <div aria-hidden="true" className="pointer-events-none">
      <img
        src={corners}
        alt=""
        draggable={false}
        decoding="async"
        className="fixed bottom-0 left-1/2 z-0 h-auto w-[max(100vw,860px)] max-w-none -translate-x-1/2 select-none max-md:hidden"
      />
      <div className="fixed bottom-0 left-0 z-0 aspect-[560/900] w-[50vw] overflow-hidden md:hidden">
        <img src={corners} alt="" draggable={false} decoding="async" className={cn(img, "left-0")} />
      </div>
      <div className="fixed right-0 bottom-0 z-0 aspect-[560/900] w-[50vw] overflow-hidden md:hidden">
        <img src={corners} alt="" draggable={false} decoding="async" className={cn(img, "right-0")} />
      </div>
    </div>
  );
}
